/**
 * V1.1 Task 4 (2026-04-26) — Admin client for the orphan audit dry-run
 * report. Backed by `GET /admin/storage/orphan-audit` (Workers Analytics
 * Engine reader on the API side).
 *
 * Read-only — no delete or trigger actions are exposed in V1.1. Explicit
 * orphan delete will land as a separate task with operator confirmation.
 */

import { apiFetch } from "./client";

export type PrefixBreakdownEntry = {
  readonly prefix: string;
  readonly count: number;
};

export type LatestOrphanRun = {
  readonly count: number;
  readonly total_bytes: number;
  readonly prefix_breakdown: ReadonlyArray<PrefixBreakdownEntry>;
  readonly oldest_created_at_unix_ms: number | null;
  readonly run_at: number;
  readonly is_prod: boolean;
  readonly partial_scan: boolean;
};

export type OrphanHistoryEntry = {
  readonly run_at: number;
  readonly count: number;
  readonly total_bytes: number;
  readonly is_prod: boolean;
};

export type OrphanAuditReport = {
  readonly latest_run: LatestOrphanRun | null;
  readonly history: ReadonlyArray<OrphanHistoryEntry>;
};

export async function fetchOrphanAuditReport(): Promise<OrphanAuditReport> {
  const res = await apiFetch<{ data: OrphanAuditReport }>(
    "/admin/storage/orphan-audit",
  );
  return res.data;
}
